import Reveal from "@/components/Reveal";

const ROWS = [
  {
    title: "You run the same loop in new clothing.",
    body: "New role, new city, new relationship — and somehow the same ending. That's not bad luck. It's a pattern asking to be seen.",
  },
  {
    title: "You've done the work. The loop stayed.",
    body: "Books, frameworks, maybe therapy. You understand yourself intellectually — and still react the same way at 11pm. Understanding is not the same as seeing.",
  },
  {
    title: "You're done managing symptoms.",
    body: "Another coping strategy is another layer of clothing on the same loop. This work goes down — the vertical — to the root the pattern grew from.",
  },
];

export default function WhoFor() {
  return (
    <section id="who" className="relative py-24 md:py-36" data-testid="who-section">
      <div
        className="absolute top-0 right-0 w-[480px] h-[480px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(169,129,47,0.075), transparent 60%)" }}
        aria-hidden="true"
      />
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <Reveal>
            <p className="eyebrow mb-6">Who this is for</p>
            <h2
              className="font-display text-ink font-medium leading-[1.12] text-4xl sm:text-5xl lg:text-6xl"
              data-testid="who-heading"
            >
              High-functioning is not the same as <em className="italic text-goldink">well</em>.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 text-inkdim leading-relaxed max-w-xl text-[15px] md:text-base">
              For the self-aware, quietly exhausted ones — the people everyone leans on,
              who hold everything together in public and run the same private loop at night.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 md:mt-20">
          {ROWS.map((row, i) => (
            <Reveal key={row.title} delay={i * 0.08}>
              <div className="grid md:grid-cols-12 gap-4 md:gap-10 py-9 border-t border-[rgba(169,129,47,0.26)] group">
                <span className="md:col-span-1 text-[11px] tracking-[0.3em] text-gold/70 pt-2">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="md:col-span-5 font-display text-2xl md:text-[1.7rem] text-ink leading-snug group-hover:text-goldink transition-colors duration-500">
                  {row.title}
                </h3>
                <p className="md:col-span-6 text-inkdim text-sm md:text-[15px] leading-relaxed md:pt-1">
                  {row.body}
                </p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-[rgba(169,129,47,0.26)]" />
        </div>
      </div>
    </section>
  );
}
